import React from 'react';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import ReactMarkdown from 'react-markdown';

import Icon from '@mdi/react';
import { mdiDownload  } from '@mdi/js';

const DatenschutzPage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.DatenschutzPageData.edges[0]

  const { edges: datenschutz } = props.data.datenschutz;
  return (
      <Layout>
        <Helmet>
          <html lang='de' /> 
          <title>Datenschutzerklärungen - presono</title>
          <meta
            name="description"
            content="Datenschutzerklärungen der presono GmbH"
          />
        </Helmet>
        <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />
        <section>
          <div className="container">
            <div className="columns secondarypage impressum">
              <div className="columns is-12">
                <div className="row" id="row-1515269463">
                  <div className="col small-12 large-12">
                    <div className="col-inner">

                        <div className="headliner top starfield b1 t1 pusher">
                          <h1>Datenschutzerklärung <small> der presono GmbH </small></h1>
                          <p>für die Verarbeitung der personenbezogenen Daten
von Kunden und Nutzern</p>
                        </div>

                        <div className="blogpage">
                          <div className="blog-content">
                              <div className="container">

                              <ReactMarkdown source={datenschutz[0].node.html} escapeHtml={false}/>

                              <a className="button is-rounded features-button" target="_blank" href={datenschutz[0].node.frontmatter.download}>
                                    <span className="icon">
                                    <Icon path={mdiDownload}
                                        size={"20px"}
                                        color="#fff"
                                        />
                                    </span>
                                    <span>Download als .PDF</span>
                                </a>
                                <br />
                                <br />
                                <a className="button is-rounded features-button" href="javascript:salessuckers?salessuckers.optOut():false">Tracking deaktivieren</a>
                              </div>
                          </div>
                        </div>
                      </div>
                   </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Newsletter newsletter={data.frontmatter} locale={locale} />
        <Footer locale={locale} />
      </Layout>
  )
}

export default DatenschutzPage;

DatenschutzPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query DatenschutzContent($locale: String) {
  DatenschutzPageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_datenschutz"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          langSwitch
        }
      }
    }
  }
  datenschutz: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "datenschutz"}}}
    ) {
    edges {
      node {
        html
        fields {
          slug
        }
        frontmatter {
          title
          pageKey
          locale
          download
        }
      }
    }
  }
}
`;

